<template>
    <!-- iq-card -->
    <b-col xs="12" sm="12" md="12" lg="12" xl="12">
        <iq-card>
            <template v-slot:body>
                <b-row class="details">
                    <!-- budget_mains -->
                    <b-table-simple striped bordered small hover>
                        <tbody>
                        <b-tr>
                            <b-th colspan="6"><h5 class="text-white text-center" style="font-size: 15px; background-color: #005B5B; padding: 2px">{{ $t('grant_budget_management.budget_preparation') }}</h5></b-th>
                        </b-tr>
                        <b-tr>
                            <b-th colspan="1">{{ $t('grant_budget_management.organization') }}</b-th>
                            <b-td colspan="5">{{ getOrganizationById(budget_mains.org_id) }}</b-td>
                        </b-tr>

                        <b-tr>
                            <b-th>{{ $t('grant_budget_management.fiscal_year') }}</b-th>
                            <b-td>{{  getFiscalYearById(budget_mains.fiscal_year_id) }}</b-td>

                            <b-th>{{ $t('grant_budget_management.amount') }}</b-th>
                            <b-td>{{ $n(budget_mains.amount) }}</b-td>
                            <b-th v-if="budget_mains.process_status === 3" >{{ $t('grant_budget_management.approve_amount') }}</b-th>
                            <b-td v-if="budget_mains.process_status === 3">{{ $n(budget_mains.approve_amount) }}</b-td>
                        </b-tr>
                        </tbody>
                    </b-table-simple>

                    <!-- budget_mains.service_types -->
                    <b-table-simple striped bordered small hover>
                        <tbody>
                        <b-tr>
                            <b-th colspan="6"><h5 class="text-white text-center" style="font-size: 15px; background-color: #005B5B; padding: 2px">{{ $t('grant_budget_management.service_type_wise_budget') }}</h5></b-th>
                        </b-tr>

                        <b-tr v-for="(item,index) in budget_mains.service_types" :key=index>
                            <b-th>{{ $t('grant_budget_management.service_type') }}</b-th>
                            <b-td>{{  getServiceTypeById(item.service_type_id) }}</b-td>

                            <b-th>{{ $t('grant_budget_management.amount') }}</b-th>
                            <b-td>{{ $n(item.amount) }}</b-td>
                            <b-th v-if="budget_mains.process_status === 3">{{ $t('grant_budget_management.approve_amount') }}</b-th>
                            <b-td v-if="budget_mains.process_status === 3">{{ $n(item.approve_amount) }}</b-td>
                        </b-tr>
                        </tbody>
                    </b-table-simple>

                    <!-- budget_mains.services -->
                    <b-table-simple striped bordered small hover>
                        <tbody>
                        <b-tr>
                            <b-th colspan="8"><h5 class="text-white text-center" style="font-size: 15px; background-color: #005B5B; padding: 2px">{{ $t('grant_budget_management.service_wise_budget') }}</h5></b-th>
                        </b-tr>
                        <b-tr v-for="(item,index) in budget_mains.services" :key=index>
                            <b-th>{{ $t('grant_budget_management.service_type') }}</b-th>
                            <b-td>{{  getServiceTypeById(item.service_type_id) }}</b-td>

                            <b-th>{{ $t('grant_budget_management.service_name') }}</b-th>
                            <b-td>{{  getServiceById(item.service_id) }}</b-td>

                            <b-th>{{ $t('grant_budget_management.amount') }}</b-th>
                            <b-td>{{ $n(item.amount) }}</b-td>
                            <b-th v-if="budget_mains.process_status === 3" >{{ $t('grant_budget_management.approve_amount') }}</b-th>
                            <b-td v-if="budget_mains.process_status === 3" >{{ $n(item.approve_amount) }}</b-td>
                        </b-tr>
                        </tbody>
                    </b-table-simple>
                    <!-- budget approval send notes -->
                    <b-table-simple striped bordered small hover v-if="sendNote.length > 0" >
                        <tbody>
                        <b-tr>
                            <b-th colspan="6"><h5 class="text-white text-center" style="font-size: 15px; background-color: #005B5B; padding: 2px">{{ $t('grant_budget_management.send_note') }}</h5></b-th>
                        </b-tr>
                        <b-tr v-for="(item,index) in sendNote" :key=index>
                            <b-th>{{ $t('grant_budget_management.note') }}</b-th>
                            <b-td>{{  (item.note) }}</b-td>
                            <b-th>{{ $t('grant_budget_management.note_bn') }}</b-th>
                            <b-td>{{  item.note_bn }}</b-td>

                            <b-th>{{ $t('grant_budget_management.approved_by') }}</b-th>
                            <b-td>{{approvedBy(item.created_by)}}</b-td>
                        </b-tr>
                        </tbody>
                    </b-table-simple>
                    <!-- budget approval approved notes -->
                    <b-table-simple striped bordered small hover v-if="approveNote.length > 0" >
                        <tbody>
                        <b-tr>
                            <b-th colspan="6"><h5 class="text-white text-center" style="font-size: 15px; background-color: #005B5B; padding: 2px">{{ $t('grant_budget_management.approve_note') }}</h5></b-th>
                        </b-tr>
                        <b-tr v-for="(item,index) in approveNote" :key=index>
                            <b-th>{{ $t('grant_budget_management.note') }}</b-th>
                            <b-td>{{  (item.note) }}</b-td>
                            <b-th>{{ $t('grant_budget_management.note_bn') }}</b-th>
                            <b-td>{{  item.note_bn }}</b-td>

                            <b-th>{{ $t('grant_budget_management.approved_by') }}</b-th>
                            <b-td>{{approvedBy(item.created_by)}}</b-td>
                        </b-tr>
                        </tbody>
                    </b-table-simple>
                </b-row>
            </template>
            <b-col class="text-right">
                <b-button variant="danger" class="mr-1" @click="$bvModal.hide('modal-5')">{{ $t('globalTrans.cancel') }}</b-button>
            </b-col>
        </iq-card>
    </b-col>
</template>

<script>
// import Custom from '@/store/custom'

export default {
    props: ['id'],
    data () {
        return {
            budget_mains: {},
            sendNote: [],
            approveNote: []
        }
    },
    created () {
        this.budget_mains = this.getBudget()
        this.sendNote = this.budget_mains.notes.filter((item) => item.type === 1)
        this.approveNote = this.budget_mains.notes.filter((item) => item.type === 2)
    },
    computed: {
        currentLocale: function () {
            return this.$i18n.locale
        }
    },
    methods: {
        approvedBy (value) {
            if (value) {
              const user = this.$store.state.GrantAllowanceService.commonObj.userList.find((item) => item.value === value)
                return this.$i18n.locale === 'bn' ? user.text_bn : user.text_en
            } else {
                return ''
            }
        },
        getBudget () {
            const tmpData = this.$store.state.list.find(item => item.id === this.id)
            return tmpData === undefined ? {} : JSON.parse(JSON.stringify(tmpData))
        },
        getOrganizationById (id) {
            const tmp = this.$store.state.orgList.find(item => item.value === id)
            return tmp ? tmp.text : ''
        },
        getFiscalYearById (id) {
            const tmp = this.$store.state.commonObj.fiscalYearList.find(item => item.value === id)
            return tmp ? tmp.text : ''
        },
        getServiceTypeById (id) {
            const tmp = this.$store.state.GrantAllowanceService.commonObj.serviceTypeList.find(item => item.value === id)
            if (tmp === undefined) return ''
            return this.$i18n.locale === 'en' ? tmp.text_en : tmp.text_bn
        },
        getServiceById (id) {
            const tmp = this.$store.state.GrantAllowanceService.commonObj.serviceNameList.find(item => item.value === id)
            if (tmp === undefined) return ''
            return this.$i18n.locale === 'en' ? tmp.text_en : tmp.text_bn
        }
    }
}
</script>
<style lang="scss">
.details {
    h5 {
        color: green !important;
        font-size: 20px !important;
    }
    .table-bordered td:nth-child(2n+1) {
        font-weight: 700;
    }
}
.hidden_header {
    display: none
}
[dir=ltr][mode=light] .card-body {
    flex: 1 1 auto;
    min-height: 1px;
    padding: 10px;
}
</style>
